import { render } from "./MarkdownToc.vue?vue&type=template&id=38b0f8e4&scoped=true"
import script from "./MarkdownToc.vue?vue&type=script&lang=js"
export * from "./MarkdownToc.vue?vue&type=script&lang=js"

import "./MarkdownToc.vue?vue&type=style&index=0&id=38b0f8e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b0f8e4"]])

export default __exports__